<div class="kf-editable-field">
    @if (isEditable$ | async; as editable) {
        <div class="d-flex
             {{'kf-field-xs-' + labelCols}}
             {{'kf-field-sm-' + labelColsSm}}
             {{'kf-field-md-' + labelColsMd}}
             {{'kf-field-lg-' + labelColsLg}}
             {{'kf-field-xl-' + labelColsXl}}
             {{'kf-field-xxl-' + labelColsXxl}}">
            <div class="kf-input-label kf-label label-text">
                {{label}}
                @if (helpText) {
                    <span class="kf-tooltip" [ngbTooltip]="helpText" [placement]="['top', 'right']">
                        <i class="fas fa-info-circle"></i><span class="sr-only">{{helpText}}</span>
                    </span>
                }
            </div>
            @if (listOfOptions$ | async; as options) {
                <div class="kf-input col">
                    <div [class.d-flex]="layout==layoutMode.Horizontal">
                        @for (option of options; track option; let i = $index) {
                            <div class="form-check" [class.pe-4]="layout==layoutMode.Horizontal">
                                <input type="radio"
                                       [name]="obj"
                                       [id]="id + '_' + option.value"
                                       [value]="option.value"
                                       (click)="onClick(option.value)"
                                       [(ngModel)]="obj[prop]"
                                       class="form-check-input">
                                <label class="radio-label form-check-label" for="{{id + '_' + option.value}}">
                                    {{option.label}}
                                    @if (option.helpText!='') {
                                        <span class="kf-tooltip" [ngbTooltip]="option.helpText" [placement]="['top', 'right']">
                                            <i class="fas fa-info-circle"></i><span class="sr-only">{{option.helpText}}</span>
                                        </span>
                                    }
                                </label>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
        <!--  Errors/Warnings  -->
        <observable-errors-warnings [obj]="obj" [props]="[prop]" [useSingleAlert]="true"></observable-errors-warnings>
    }
    @else {
        <div class="d-flex
             {{'kf-field-xs-' + labelCols}}
             {{'kf-field-sm-' + labelColsSm}}
             {{'kf-field-md-' + labelColsMd}}
             {{'kf-field-lg-' + labelColsLg}}
             {{'kf-field-xl-' + labelColsXl}}
             {{'kf-field-xxl-' + labelColsXxl}}">
            <div class="kf-input-label">
                <div class="kf-label">
                    {{label}}
                    @if (helpText) {
                        <span class="me-2 kf-tooltip" [ngbTooltip]="helpText" [placement]="['top', 'right']">
                            <i class="fas fa-info-circle"></i><span class="sr-only">{{helpText}}</span>
                        </span>
                    }
                </div>
            </div>
            <div class="kf-input col">{{readOnlyValue$ | async}}</div>
        </div>
        @if (!!allowReadOnlyWarnings) {
            @if (this.warning$ | async; as warning) {
                <!--  Optionally show warnings only in read-only mode  -->
                <observable-errors-warnings [obj]="obj" [props]="[prop]" [useSingleAlert]="true" [supressErrors]="true"></observable-errors-warnings>
            }
        }
    }
</div>

